import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Link, Box, Typography, useMediaQuery } from '@mui/material';
import FormattedTranslation from 'components/Common/FormattedTranslationMui';

const Privacy = ({ url }) => (
  <Link href={url} target="_blank">
    <FormattedTranslation id="page.login.terms.privacyLink" />
  </Link>
);

Privacy.propTypes = {
  url: PropTypes.string.isRequired,
};

const Terms = ({ url }) => (
  <Link href={url} target="_blank">
    <FormattedTranslation id="page.login.terms.termsLink" />
  </Link>
);

Terms.propTypes = {
  url: PropTypes.string.isRequired,
};

const TermsAndConditions = ({ privacyUrl, termsUrl }) => (
  <Box mx={useMediaQuery(useTheme().breakpoints.down('sm')) ? 6 : 11} textAlign="center">
    <Typography>
      <FormattedTranslation
        id="page.login.terms.full"
        values={{ privacy: <Privacy url={privacyUrl} />, terms: <Terms url={termsUrl} /> }}
      />
    </Typography>
  </Box>
);

TermsAndConditions.propTypes = {
  privacyUrl: PropTypes.string.isRequired,
  termsUrl: PropTypes.string.isRequired,
};

export default TermsAndConditions;
